/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  // Rebuy warranty sync
  (() => {
    document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
      const removedItem = event.detail.item;

      // Check if the item that was just removed was the warranty addon
      const wasAddon =
        removedItem.title.toLowerCase().includes("chill+") &&
        removedItem.title.toLowerCase().includes("warranty");

      if (removedItem.properties && removedItem.properties._warranty) {
        // Removing the ADDON product
        if (wasAddon) {
          // Get the variant ID of the main product this addon was linked to
          const linkedMainProductId = removedItem.properties._warranty;

          // Find the main product that is still in the cart
          const mainProduct = window.Rebuy.SmartCart.items().find(
            (item) => item.variant_id.toString() === linkedMainProductId
          );

          // If the main product is found, remove its property
          if (mainProduct) {
            window.Rebuy.Cart.removeItem(mainProduct, () => {
              delete mainProduct.properties._warranty;

              window.Rebuy.Cart.addItem(mainProduct);
            });
          }
        } else {
          // This block runs if the removed item was NOT an addon, but WAS part of a pair.

          // Find the addon that was linked to the removed main product
          const addonToRemove = window.Rebuy.SmartCart.items().find(
            (item) => item.properties && item.properties._warranty === removedItem.variant_id.toString()
          );

          // If the linked addon is found, remove it from the cart
          if (addonToRemove) {
            window.Rebuy.SmartCart.removeItem(addonToRemove);
          }
        }
      }
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
